<div #modal class="modal fade" role="dialog" tabindex="-1" style="z-index: 10000" [ngClass]="modalSize ? 'modal-'+modalSize : ''">
  <div class="modal-dialog" role="document">
    <ng-template #container></ng-template>
  </div>
</div>
